import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import {  ActivatedRoute, Router } from '@angular/router';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
declare var $: any;
import * as _ from 'lodash';
import { Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { DataTableDirective } from 'angular-datatables';
import { AlertComponent } from 'src/app/structure/alert/alert.component';
import { Sh3Service } from 'src/app/services/sh3.service';
@Component({
  selector: 'app-sh3list',
  templateUrl: './sh3list.component.html',
  styleUrls: ['./sh3list.component.css']
})
export class Sh3listComponent implements OnInit {

  public environmentSettings: any;
  isSearchDivVisible = false;
  @ViewChildren(DataTableDirective)
  dtElements: QueryList<DataTableDirective>;
  dtOptionsOfSh3: DataTables.Settings = {};
  dtOptionsOfMasterDirector: DataTables.Settings = {};
  dtOptionsOfRegisterDirector: DataTables.Settings = {};
  registerDirectorList: any[];
  deletebankdetails:any ;
  masterDirectorList: any[];
  FromDateModelInMasterDirector: any;
  ToDateModelInMasterDirector: any;
  dtTriggerMasterDirector: Subject<any> = new Subject();
  dtTriggerRegisterDirector: Subject<any> = new Subject();
  dtTriggerSh3: Subject<any> = new Subject();
  error: any = { isError: false, errorMessage: '' };
  futureToDate: NgbDateStruct;
  futureFromDate: NgbDateStruct;
  currentURL : any;
  response: boolean;
  deleteSh3: any;
  folioNo:any;
  dateOfIssueOfSweat: any;
  dateOfIssueOfSweatTo: any;
  statusOfAllotee:any;
  editParticularId: any;
  

  constructor(private sh3 : Sh3Service, private router: Router,  
     private alert: AlertComponent,private activatedRoute: ActivatedRoute) { 
    this.response = false;
  }

  ngOnInit() {

    this.environmentSettings = environment;
    let searchflag = localStorage.getItem('searchdireflag');
 

    this.dtOptionsOfSh3 = {
      destroy: true,
      scrollX: true,
      scrollY: "210px",
      scrollCollapse: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      stateSave: true,
      stateDuration: -1,
      search: true,
      order: [0, 'asc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [7] }],
      dom: 'lBfrtip',//'Bfrtip',
      buttons: [
        {
          text: '<i class="fa fa-files-o"></i> Export to Excel',
          className: 'btn btn-sm btn-warning export-btn',
          filename: 'Sh-3',
          title: 'Sh-3',
          extend: 'excel',
          exportOptions: {
            columns: [0, 1, 3, 4, 6],
            format: {
              body: function ( data, row, column, node ) {
                  if(data.includes("+") || data.includes("@") || data.includes("=") || data.includes("|") || data.includes("!")){
                    if(data.match(/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z0-9.-]+$/)){  return data }else{ return  "'" + data + "'"; }
                  }else{ return data }
                }
            }
          }
 
        }
      ]
    };
 
    this.getRegisterDirectorList();

  }
 
  addsh3(){
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['sh-3','add']  } }],
      { relativeTo: this.activatedRoute.parent });
  }
 

 
  adjustdirectormasterTable() {
  
      setTimeout(() => {
        $("#directormasterSh3Table").DataTable().columns.adjust().draw();
      }, 200);
    }
  
 

  tabRegisterOfDirectorOnClickEvent() {
    setTimeout(() => {
      $("#directormasterSh3Table").DataTable().columns.adjust().draw();
    });
  }
 
 
  getRegisterDirectorList() {
 
    this.registerDirectorList = [];
    this.sh3.getRegisterDirector({ isSearch: false }).subscribe(registerList => {
      
      $("#directormasterSh3Table").DataTable().destroy();
      this.registerDirectorList = registerList.data;
      this.dtTriggerSh3.next();
      
      // setTimeout(() => {
      //   this.dtTriggerSh3.next();
      // }, 200);
    });
  }


  generateOutput() {
    let companyId = JSON.parse(localStorage.getItem('companyDetails')).companyID;
    var object = {
      id: null,
      fromDate: this.dateOfIssueOfSweat,
      toDate: this.dateOfIssueOfSweatTo,
      param1: this.folioNo,
      param2: this.statusOfAllotee
    }
    this.sh3.generateSh3Document(object).subscribe(response => {
      if (response.status == 0) {
        this.alert.success(response.message);
        var self = this;
        setTimeout(function () {
          self.downloadDocument(companyId);
          setTimeout(function () {
            self.downloadPdfDocument(companyId);
          }, 1000);
        }, 1000);
      } else {
        this.alert.error(response.message);
      }
    })
  }
  
  downloadDocument(id) {
    this.sh3.downloadSh3File(id, 'Multi');
  }
  downloadPdfDocument(id) {
    this.sh3.downloadSh3PdfFile(id, 'Multi');
  }
  
  confirmDelete(id) {
    this.deleteSh3 = id;
    $("#deleteConfirm").modal('toggle');
  }



 deleteSh3Data() {
  this.sh3.removesh3details(this.deleteSh3)
    .subscribe(response => {
      if (response.status == 0) {
        this.alert.success(response.message);
        $("#directormasterSh3Table").DataTable().destroy();
        $("#deleteConfirm").modal('toggle');
        this.getRegisterDirectorList();
      } else {
        this.alert.error(response.message);
      }
   

    });

}
editSh3Details(_id) {
  this.router.navigate(
    [{ outlets: { 'structure-outlet': ['sh-3','edit',_id]  } }],
    { relativeTo: this.activatedRoute.parent });
  // this.router.navigate(['/sh-3/edit/', _id]);
}
getMbpById(_id) {
  this.router.navigate(
    [{ outlets: { 'structure-outlet': ['sh-3','edit',_id]  } }],
    { relativeTo: this.activatedRoute.parent });
  // this.router.navigate(['sh3/update/', _id]);
}
setDate(date) {
  if (date != "" && date != null) {
    return date.month + "-" + date.day + "-" + date.year;
  }
  return null;
}
toggleSearchDiv() {
  this.isSearchDivVisible = !this.isSearchDivVisible;
}
doAdvSearch() {
  
  this.response = true;

  var searchParam =
  {
    "folioNo": this.folioNo,
    "dateOfIssueOfSweat":this.setDate(this.dateOfIssueOfSweat),
    "dateOfIssueOfSweatTo":this.setDate(this.dateOfIssueOfSweatTo),
     "statusOfAllotee": this.statusOfAllotee,
    'isSearch': true,
  };
  this.registerDirectorList = [];
  $("#directormasterSh3Table").DataTable().destroy();
  this.sh3.getRegisterDirector(searchParam).subscribe(registerList => {
    this.response = false;
    this.registerDirectorList = registerList.data;
    this.dtTriggerSh3.next();
  });
}
clearAdvSearch() {
  this.folioNo = '';
  this.dateOfIssueOfSweat = '';
  this.dateOfIssueOfSweatTo = '';
  this.statusOfAllotee = '';

  $("#directormasterSh3Table").DataTable().destroy();
  this.getRegisterDirectorList();
}
}

